/* eslint-disable max-len */
import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { enqueueSnackbar } from 'actions';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors } from '@mui/material';
import { RunFileUpload } from '../actions/FocusOccasionUploadActions.js';
import MediaCard from './FocusOccasionCard';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const FocusOccasionFilesUpload = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);

	const _FocusOccasionFilesUpload = file => {
		file.forEach(element => {
			// eslint-disable-next-line max-len
			if (!element.name.includes('Focus_Occasion_Events')) {
				dispatch(
					enqueueSnackbar({
						message: `File ${element.name} not valid. Please check file nomenclature.`,
						options: { variant: 'warning' }
					})
				);
			} else {
				const username = `${user.firstname} ${user.lastname}`;
				dispatch(RunFileUpload(element, username, user.id));
			}
		});
	};

	return (
		<Page className={classes.root}>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<Typography gutterBottom variant="h3" component="div">
							Focus Occasion Events Upload
						</Typography>
						<br />
						<Grid container spacing={1}>
							<Grid item md={12} xs={12}>
								<MediaCard />
								<br />
								<FilesDropzone upload={_FocusOccasionFilesUpload} />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default FocusOccasionFilesUpload;
